<template>
  <div class='h-dialogContainer h-alarm-filter'>
    <div class='row h-row-around-inputBox'>
      
      <div class='col-sm-6'>
        <!-- <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{ $t("Alarm.createTime") }}({{ $t('Alarm.notifystart') }}):</div>
          <ejs-datetimepicker v-model='createStartTime' :allowEdit='false' :locale='locale' :format='dateFormat' :step='15' timeFormat='HH:mm:ss'></ejs-datetimepicker>
        </div> -->
        <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{ $t("Alarm.clearTime") }}({{ $t('Alarm.notifystart') }}):</div>
          <ejs-datetimepicker v-model='clearStartTime' :allowEdit='false' :locale='locale' :format='dateFormat' :step='15' timeFormat='HH:mm:ss'></ejs-datetimepicker>
        </div>
        
      </div>
      <div class='col-sm-6'>
        <!-- <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{ $t("Alarm.createTime") }}({{ $t('Alarm.notifyend') }}):</div>
          <ejs-datetimepicker v-model='createEndTime' :allowEdit='false' :locale='locale' :format='dateFormat' :step='15' timeFormat='HH:mm:ss'></ejs-datetimepicker>
        </div> -->
        <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{ $t("Alarm.clearTime") }}({{ $t('Alarm.notifyend') }}):</div>
          <ejs-datetimepicker v-model='clearEndTime' :allowEdit='false' :locale='locale' :format='dateFormat' :step='15' timeFormat='HH:mm:ss'></ejs-datetimepicker>
        </div>
        
      </div>
    </div>
    <div class='row h-row-around-inputBox'>
      <div class='col-sm-6'>
        <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{ $t('Alarm.alarmLevel') }}:</div>
          <div class='row' id='eventLevelBox'>
            <div v-for='(event, index) in alarmLevelList' :key='index' class='col-sm-3 nopadding'>
              <ejs-checkbox ref='eventLevelRef' :label='event.label' :value='event.value' :checked='event.checked'></ejs-checkbox>
            </div>
          </div>
        </div>
      </div>
      <div class='col-sm-6'>
        <div class='h-col-inputBox'>
          <div class='h-inputLit'>{{ $t("Alarm.alarmType") }}:</div>
          <div class='row' id='eventTypeBox'>
            <div v-for='(event, index) in alarmTypeList' :key='index' class='col-sm-6 nopadding3'>
              <ejs-checkbox :label='event.label' :value='event.value' :checked='event.checked'></ejs-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class='row h-reset-margin'>
      <div class='h-outTabs h-dislogTabs'>
        <ejs-tab ref='filterTab' heightAdjustMode='Auto'>
          <!-- <e-tabitems> -->
            <!-- <e-tabitem :header='tab.name.header' content='#eventLogTopoTree'></e-tabitem>
            <e-tabitem :header='tab.type.header' content='#neTypeDom'></e-tabitem> -->
            <div class='e-tab-header'>
              <div>{{ this.$t('Alarm.nodeSelect') }} {{ this.$t('Alarm.byName') }}</div>
              <!--<div>{{ this.$t('Alarm.nodeSelect') }} {{ this.$t('Alarm.byType') }}</div>-->
            </div>
            <div class='e-content'>
              <div id='eventLogTopoTree'>
                <div class='h-padding-25'>
                  <div class='h-borderBox height-280'>
                    <TopoTree ref='filterTopoTree' :searchBox='{ show: true }' :checkBox='{ show: true }' :hasBorder='true' graphType="0"></TopoTree>

                  </div>
                </div>
                <div class='h-clear-bottomPadding'></div>
              </div>
              <!--
              <div id='neTypeDom'>
                <div class='h-padding-25'>
                  <div id='neTypeListDom' class='row height-280'>
                    <div v-for='(neType, index) in neTypeList' :key='index' class='col-sm-4 m-b-10'>
                      <ejs-checkbox :label='neType.label.toUpperCase()' :value='neType.value' :checked='neType.checked'></ejs-checkbox>
                    </div>
                  </div>
                </div>
              </div>
              -->
            </div>
          <!-- </e-tabitems> -->
        </ejs-tab>
        
      </div>
    </div>
  </div>
</template>
<script>
import TopoTree from '../../topoconfig/TopoTree';
import { EventBus } from '../../../plugins/eventBus';

export default {
  name: 'historyStaticsFilter',
  components: {
    TopoTree
  },
  data() {
    return {
      dateFormat: 'yyyy-MM-dd HH:mm:ss',
      alarmLevelList: [
        { label: this.$t('Alarm.alarmLevel_0'), value: '0', checked: false },
        { label: this.$t('Alarm.alarmLevel_1'), value: '1', checked: false },
        { label: this.$t('Alarm.alarmLevel_2'), value: '2', checked: false },
        { label: this.$t('Alarm.alarmLevel_3'), value: '3', checked: false }
      ],
      alarmTypeList: [
        { label: this.$t('Alarm.alarmType_0'), value: '0', checked: false },
        { label: this.$t('Alarm.alarmType_1'), value: '1', checked: false },
        { label: this.$t('Alarm.alarmType_2'), value: '2', checked: false },
        { label: this.$t('Alarm.alarmType_3'), value: '3', checked: false },
        { label: this.$t('Alarm.alarmType_4'), value: '4', checked: false }
      ],
      neTypeList: [],
      topoList: [],
      tab: {
        name: {
          header: { text: `${this.$t('Alarm.nodeSelect')}(${this.$t('Alarm.byName')})` }
        },
        // type: {
        //   header: { text: `${this.$t('Alarm.nodeSelect')}(${this.$t('Alarm.byType')})` }
        // }
      },
      locale: localStorage.getItem('locale'),
      // createStartTime: '',
      clearStartTime: '',
      // createEndTime: '',
      clearEndTime: '',
      conditions: {
        selectType: '0', // 0名称，1类型
        // createStartTime: '',
        clearStartTime: '',
        // createEndTime: '',
        clearEndTime: '',
        ne: [],
        nodeIds: [],
        nodeTypeId: []
      }
      
    };
  },
  
  methods: {
    
    turnToFormateDate(dateValue) {
      dateValue = new Date(dateValue);
      let month = dateValue.getMonth() + 1;
      if (month < 10) {
        month = `0${month}`;
      }
      let day = dateValue.getDate();
      if (day < 10) {
        day = `0${day}`;
      }
      let hour = dateValue.getHours();
      if (hour < 10) {
        hour = `0${hour}`;
      }
      let minutes = dateValue.getMinutes();
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      let sec = dateValue.getSeconds();
      if (sec < 10) {
        sec = `0${sec}`;
      }
      return `${dateValue.getFullYear()}-${month}-${day} ${hour}:${minutes}:${sec}`;
    },
    
    getArray(id) {
      const checkedDom = document.querySelectorAll(`#${id} [aria-checked=true] input`);
      const array = [];
      for (let i = 0; i < checkedDom.length; i++) {
        array.push(checkedDom[i].value);
      }
      return array;
    },
    setCondition(json) {
      if (json === undefined) {
        json = JSON.stringify({
          selectType: '0',
          nodeIds: [],
          nodeTypeId: []
        });
      }
      const conditions = JSON.parse(json);
      // this.createStartTime = conditions.createStartTime ? this.turnToFormateDate(conditions.createStartTime) : '';
      // this.createEndTime = conditions.createEndTime ? this.turnToFormateDate(conditions.createEndTime) : '';
      this.clearStartTime = conditions.clearStartTime ? this.turnToFormateDate(conditions.clearStartTime) : '';
      this.clearEndTime = conditions.clearEndTime ? this.turnToFormateDate(conditions.clearEndTime) : '';
      
      for (let i = 0; i < this.alarmLevelList.length; i++) {
        this.alarmLevelList[i].checked = false;
        if (conditions.alarmLevel) {
          for (let j = 0; j < conditions.alarmLevel.length; j++) {
            if (conditions.alarmLevel[j] === this.alarmLevelList[i].value) {
              this.alarmLevelList[i].checked = true;
            }
          }
        }
      }
      for (let i = 0; i < this.alarmTypeList.length; i++) {
        this.alarmTypeList[i].checked = false;
        if (conditions.alarmType) {
          for (let j = 0; j < conditions.alarmType.length; j++) {
            if (conditions.alarmType[j] === this.alarmTypeList[i].value) {
              this.alarmTypeList[i].checked = true;
            }
          }
        }
      }
      for (let i = 0; i < this.neTypeList.length; i++) {
        this.neTypeList[i].checked = false;
        if (conditions.nodeTypeId) {
          for (let j = 0; j < conditions.nodeTypeId.length; j++) {
            if (conditions.nodeTypeId[j] === this.neTypeList[i].value) {
              this.neTypeList[i].checked = true;
            }
          }
        }
      }
      this.$refs.filterTopoTree.uncheckAll();
      this.$refs.filterTopoTree.neIdListCache = {};
      for (let i = 0; i < this.topoList.length; i++) {
        this.$refs.filterTopoTree.neIdListCache[`${this.topoList[i]}`] = true;
      }
      this.$refs.filterTopoTree.change('');
      const tabObj = this.$refs.filterTab.ej2Instances;
      tabObj.select(parseInt(conditions.selectType, 10));
    },
    getCondition() {
      const returnData = JSON.parse(JSON.stringify(this.conditions));
      const levelData = this.getArray('eventLevelBox');
      if (levelData.length > 0) {
        returnData.alarmLevel = levelData;
      }
      const typeData = this.getArray('eventTypeBox');
      if (typeData.length > 0) {
        returnData.alarmType = typeData;
      }
      // if (this.createStartTime) {
      //   if (!this.createEndTime) {
      //     EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.pleaseSelectEndTime')});
      //     return false;
      //   }
        
      //   returnData.createStartTime = new Date(this.createStartTime).getTime();
      // }
      // if (this.createEndTime) {
      //   if (!this.createStartTime) {
      //     EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.pleaseSelectStartTime')});
      //     return false;
      //   } else {
      //     const  createStartTime = new Date(this.createStartTime).getTime();
      //     const  createEndTime = new Date(this.createEndTime).getTime();
      //     if (createEndTime < createStartTime) {
      //       EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.EndTimeLessThanStartTime')});
      //       return false;
      //     }
      //   }
      //   returnData.createEndTime = new Date(this.createEndTime).getTime();
      // }
      if (this.clearStartTime) {
        if (!this.clearEndTime) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.pleaseSelectEndTime')});
          return false;
        }
        
        returnData.clearStartTime = new Date(this.clearStartTime).getTime();
      }
      if (this.clearEndTime) {
        if (!this.clearStartTime) {
          EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.pleaseSelectStartTime')});
          return false;
        } else {
          const  clearStartTime = new Date(this.clearStartTime).getTime();
          const  clearEndTime = new Date(this.clearEndTime).getTime();
          if (clearEndTime < clearStartTime) {
            EventBus.$emit('toast', {type: 'warning', content: this.$t('Alarm.EndTimeLessThanStartTime')});
            return false;
          }
        }
        returnData.clearEndTime = new Date(this.clearEndTime).getTime();
      }
      
      if (this.$refs.filterTab.$el.querySelectorAll('.e-tab .e-toolbar-item')[0].className.indexOf('e-active') > -1) {
        returnData.selectType = '0';
      } else {
        returnData.selectType = '1';
      }
      this.topoList = [];
      const neIdList = [];
      const nodeList = this.$refs.filterTopoTree.getNodeList();
      for (let i = 0; i < nodeList.length; i++) {
        neIdList.push(nodeList[i].id);
        this.topoList.push(nodeList[i].id);
      }
      returnData.nodeIds = neIdList;
      returnData.nodeTypeId = this.getArray('neTypeListDom');
      return JSON.stringify(returnData);
    },
    setTopoList(data) {
      this.topoList = data;
    },
    getTopoList() {
      return this.topoList;
    }
  },
  created() {
    this.$axios.get('/lte/ems/fm/event/filter').then((response) => {
      this.neTypeList = [];
      if (response && response.status === 200) {
        for (let i = 0; i < response.data.neTypeList.length; i++) {
          this.neTypeList.push({
            label: response.data.neTypeList[i].netype,
            value: response.data.neTypeList[i].netypeid,
            checked: false
          });
        }
      }
    });
  }
};
</script>
